(function () {
    'use strict';

    a3_cabin_reports.directive('flightFooter', flightFooter);


    /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name flightFooter
     * @restrict E
     * @description
     *   Implementation of FlightFooter
     *
     *   Initialize The flights Footer Template and its Navigation, Sync, Footer Functionality
     * @example
     *   Usage:
     *   <flight-footer></flight-footer>
     * @ngInject
     */
    function flightFooter(orderByFilter, $location, $sce, $timeout, $interval, $filter, apiUrl, $uibModal, $route, SettingsMain, MemoFactory, MessageFactory, FlightFactory, UserFactory, DataCleanerFactory, CabinReportLocalEditFactory, ReportGuidFactory, SyncLogFactory, CrewRouteFactory, GroundDutyFactory) {
        /**
         * Initialize flightFooter and events
         * @memberof flightFooter
         * @param {service} scope the scope of this element
         * @param {service} element element that this direcive is assigned to
         * @param {service}   attrs attribute of this element
         */
        function link(scope, element, attrs) {

            if (scope.flight) {
                var flightId = scope.flight.FlightId;
                var state = scope.state;
                var report = scope.report;
                var flights = getPreviousAndNextFlights(flightId);
                var user = UserFactory.getUser();
                var delay = 60000;

                var isAssessmentEnabled = SettingsMain.getIsAssessmentEnabled();


                var showAssessment = isAssessmentEnabled && scope.flight.assessment;
                var showFlightReport = scope.flight.LineStatus != 'na';
                var hasMultipleReports = showAssessment && !scope.flight.assessment.IsExist && showFlightReport;

                /**
                 * Find previous,next and current flight of the Route of the selected flight
                 * @memberof flightFooter
                 * @param {number} flightId input the Id of a Flight  
                 * @returns {Object} previous,next and current flight
                 */
                function getPreviousAndNextFlights(flightId) {
                    var nextFlight, previousFlight, currentFlight;

                    var flights = FlightFactory.getFlightsByRoute(scope.flight.Route, scope.flight.DutyDate);

                    flights = orderByFilter(flights, orderByDate, false);

                    function orderByDate(item) {
                        var date = new Date(item.ScheduledDeparture);
                        return date;
                    }

                    for (var i = 0; i < flights.length; i++) {
                        if (flights[i].FlightId == flightId) {
                            if (i >= 1) {
                                previousFlight = flights[i - 1];
                            }
                            if (i + 1 < flights.length) {
                                nextFlight = flights[i + 1];
                            }
                            currentFlight = flights[i];
                        }
                    }

                    return {
                        nextFlight: nextFlight,
                        previousFlight: previousFlight,
                        currentFlight: currentFlight
                    };
                }

                /**
                 * It handles the cabin report when u want to navigate to another view
                 * @memberof flightFooter
                 * @param {String} state input the current state (view)  
                 * @param {number} flightId input the Id of a Flight  
                 * @param {Object} report input the cabin report  
                 */
                function handleIfReport(state, flightId, report) {
                    if (state == 'report') {
                        if (report == null) {
                            report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
                        }
                        var guid = report.ReportGuid;
                        var status = report.Status;

                        // delete the temp report
                        CabinReportLocalEditFactory.deleteTempReport();

                        //reuse guid if this was a new report
                        if (status == 'pending')
                            ReportGuidFactory.restoreGuid(report.ReportGuid);
                    }
                }

                /**
                 * Open the Cabin Report for the  selected Flight
                 * @memberof flightFooter  
                 * @param {number} flightId input the Id of a Flight
                 */
                function openReport(flightId) {
                    var user = UserFactory.getUser();
                    var token = '';
                    if (user != null) {
                        token = user.token;
                        token = encodeURIComponent(token);
                    }

                    // load the flight
                    var flight = FlightFactory.getFlightFromStorage(flightId);
                    if (flight == null) {
                        // if not found, also check the local flights
                        var flight = FlightFactory.getLocalFlightFromStorage(flightId);
                        if (flight == null)
                            return;
                    }
                    
                

                    // load the reports
                    var serverReportForThisUser = flight.getServerCabinReportForUser(user.aimsId);
                    var serverReportsByAnotherUser = flight.getServerCabinReportsByAnotherUser(user.aimsId);
                    var localReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);

                    // no stored local report
                    if (localReport == null) {
                        // has server report from this user and from other users
                        if ((serverReportForThisUser != null) && (serverReportsByAnotherUser.length > 0)) {
                            // show selection dialog
                            openReportDialog(flightId);
                        }
                        // has server report only from this user
                        else if ((serverReportForThisUser != null) && (serverReportsByAnotherUser.length == 0)) {
                            $location.path("reportsHistory/" + serverReportForThisUser.ReportId + "/" + flightId+"/Cabin");
                        }
                        // has server report only from other users
                        else if ((serverReportForThisUser == null) && (serverReportsByAnotherUser.length > 0)) {
                            // show selection dialog
                            openReportDialog(flightId);
                        }
                        // no server reports, create a new local report directly
                        else {
                            $location.path("report/new:" + -1 + "/" + flightId);
                        }
                    }
                    // has stored local report
                    else {
                        // special case: has server report from this user, and not from
                        // other users
                        if ((serverReportForThisUser != null) && (serverReportsByAnotherUser.length == 0)) {
                            // open the local report for editing
                            $location.path("report/" + localReport.ReportGuid);
                        }
                        // general case: has server report from this user or from other
                        // users
                        else if ((serverReportForThisUser != null) || (serverReportsByAnotherUser.length > 0)) {
                            // show selection dialog
                            openReportDialog(flightId);
                        }
                        // no server reports, open the local report directly
                        else {
                            // open the existing report for editing
                            $location.path("report/" + localReport.ReportGuid);
                        }
                    }
                }

                /**
                 * Open a modal to choose an action when there is already a cabin report from another user
                 * @memberof flightFooter  
                 * @param {number} flightId input the Id of a Flight
                 */
                function openReportDialog(flightId) {
                    var modalInstance = $uibModal.open({
                        templateUrl: './views/Dialogs/dlgOpenReport.html',
                        controller: 'OpenReportDialogCtrl',
                        size: 'md',
                        resolve: {
                            flightId: function () {
                                return flightId;
                            }
                        }
                    });

                    modalInstance.result.then(function () {}, function () {});
                }

                /**
                 * Open a modal from which u can Logout from the application
                 * @memberof flightFooter  
                 */
                function logout() {
                    var isSecure = UserFactory.isSecure()
                    bootbox.dialog({
                        message: (isSecure ?
                                "<strong class='text-danger'>Due to the fact that you are working over a public computer, all stored data will be deleted on logout!</strong><br/><br/>" :
                                "You will be able to login again into the same account, even if there is no internet access.<br/><br/>") +
                            "Please confirm that you wish to log out.",
                        title: "<strong>User Logout<strong>",
                        buttons: {
                            cancel: {
                                label: "Cancel",
                                className: "btn-default",
                                callback: function () {}
                            },
                            logout: {
                                label: "Logout",
                                className: "btn-warning",
                                callback: function () {
                                    UserFactory.clearActiveUser();
                                    if (isSecure) DataCleanerFactory.deleteAllData();

                                    UserFactory.azSignOut();
                                    
                                    location.reload(true);
                                    // need to reload, in order for the
                                    // browser to check the cache.manifest
                                    // and discover any changes
                                }
                            }
                        }
                    });
                }

                /**
                 * Redirects to Reset Device View
                 * @memberof flightFooter  
                 */
                function resetDevice() {
                    SettingsMain.setEditingPage(null);
                    $location.path("/reset");
                }

                /**
                 * Open a modal from which you can delete all available reports
                 * @memberof flightFooter  
                 * @method
                 */
                function deleteAllReports() {
                    bootbox.dialog({
                        message: "Use this process to clear your device from all locally stored Cabin Reports, in order to save up space, when available storage space is not sufficient for the application to function properly.<br/><br/>" +
                            "<h4>ATTENTION</h4>" +
                            "This action will delete all Cabin Reports from your device, <span style='text-decoration: underline;'>including draft and completed ones not sent to the server</span>.",
                        title: "<strong>Application Logs Reset<strong>",
                        buttons: {
                            cancel: {
                                label: "Cancel",
                                className: "btn-default",
                                callback: function () {}
                            },
                            danger: {
                                label: "Delete All Cabin Reports",
                                className: "btn-danger",
                                callback: function () {
                                    DataCleanerFactory.deleteAllReports();
                                    $route.reload();
                                    bootbox.alert("All Cabin Reports have been successfully deleted.", function () {});
                                }
                            }
                        }
                    });
                }

                /**
                 * Navigate to Calendar View
                 * @memberof flightFooter  
                 */
                function gotoCalendar() {
                    handleIfReport(state, flightId, report);

                    SettingsMain.setEditingPage(null);
                    // go to dashboard
                    $location.path("/");
                }
                /**
                 * Navigate to Bucket Calendar View
                 * @memberof flightFooter  
                 */
                function gotoBucketCalendar() {
                    SettingsMain.setEditingPage(null);
                    $location.path('/bucket');
                }
                /**
                 * Navigate to FAQs View
                 * @memberof flightFooter  
                 */
                function gotoFAQs() {
                    SettingsMain.setEditingPage(null);
                    $location.path('/faqs');
                }
                /**
                 * Navigate to Roster Requests
                 * @memberof flightFooter  
                 */
                 function gotoRequests() {
                    SettingsMain.setEditingPage(null);
                    $location.path('/rosterRequests');
                }

                /**
                 * Navigate to Selected Flight Information View
                 * @param {number} flightId input the Id of a Flight
                 * @memberof flightFooter  
                 */
                function gotoFlight(flightId) {
                    SettingsMain.setEditingPage(null);
                    handleIfReport(state, flightId, report);
                    $location.path('/flightinfo/' + flightId);
                }

                /**
                 * Navigate to Messages View
                 * @memberof flightFooter  
                 */
                function gotoMessageLibrary() {
                    handleIfReport(state, flightId, report);
                    $location.path('/messages');
                }

                /**
                 * Navigate to the Current Flight's Information View
                 * @memberof flightFooter  
                 */
                function gotoFlightInfo() {
                    gotoFlight(flightId);
                }

                /**
                 * Navigate to Submit ticket view
                 * @memberof flightFooter  
                 */
                function gotoTicket() {
                    // go to Submit ticket view
                    $location.path("/ticket");
                }
               
                function goToSafetyReport(flightId) {
                    $location.path('/safetyreport/cabincrewreport/' + flightId);
                }

                function goToFatigueReport(flightId) {
                    $location.path('/safetyreport/fatiguereport/' + flightId);
                }

                /**
                 * Open current's Flight Cabin Report
                 * @memberof flightFooter  
                 */
                function openCabinReport() {
                    SettingsMain.setEditingPage(null);
                    openReport(flightId);
                }

                /**
                 * Navigate to the Current Flight's Pax Information View
                 * @memberof flightFooter  
                 */
                function gotoPaxInfo() {
                    SettingsMain.setEditingPage(null);
                    handleIfReport(state, flightId, report);
                    $location.path('/pax/' + flightId);
                }

                /**
                 * Open current's Flight Cabin Crew Feedback Report
                 * @memberof flightFooter  
                 */
                function openAssessment() {
                    SettingsMain.setEditingPage(null);
                    $location.path("assessment/" + flightId);
                }

                /**
                 * Open current's Flight SA Feedback Report
                 * @memberof flightFooter  
                 */
                function openSaAssessment() {
                    SettingsMain.setEditingPage(null);
                    $location.path("saAssessment/" + flightId);
                }

                /**
                 * Navigate to Memos Library
                 * @memberof flightFooter  
                 */
                function gotoMemosLibrary() {
                    SettingsMain.setEditingPage(null);
                    handleIfReport(state, flightId, report);
                    $location.path('/memos');
                }

                //todo:: clean up
                // /**
                //  * Get the latest Pax and Gate Informations
                //  * @memberof flightFooter  
                //  */
                // function SynchPaxAndGates() {
                //     var modalInstance = $uibModal.open({
                //         templateUrl: 'views/Dialogs/dlgLightSync.html',
                //         controller: 'SyncPaxCtrl',
                //         size: 'md',
                //         backdrop: 'static',
                //         keyboard: false,
                //         resolve: {
                //             flightId: function () {
                //                 return flightId;
                //             },
                //         }
                //     })

                //     modalInstance.result.then(function () {
                //         scope.lastSync = new Date().getTime();
                //     }, function () {});
                // }

                /**
                 * Opens refresh modal for results
                 */
                function RefreshRoute(){
                    var dutyNo = scope.flight.DutyNo;
                    var dutyDay = scope.flight.DutyDay;
                    var crewRouteDuty = CrewRouteFactory.getCrewRouteFromStorage(dutyNo, dutyDay);
                    var groundDuties = GroundDutyFactory.getGroundDutiesByDutyNo(dutyNo, dutyDay);
                    if(groundDuties.length > 0){    //there are ground duties in this crew route
                        angular.forEach(groundDuties, function(groundDuty)
                        {
                            groundDuty.DutyType = "Ground";
                            groundDuty.Start = groundDuty.DutyBegin;
                        });
                    }
            
                    var flights = FlightFactory.getFlightsByDutyNo(dutyNo, dutyDay);
                    if(flights.length > 0){    //there are flights in this crew route
                        angular.forEach(flights, function(flight)
                        {
                            flight.DutyType = "Flight";
                            flight.Start = flight.ScheduledDeparture;
                        });
                    }
            
                    var crewRoute = groundDuties.concat(flights);
                    crewRoute = $filter('orderBy')(crewRoute, 'Start', false);


                    var modalInstance = $uibModal.open({
                        templateUrl: 'views/CrewRoute/dlgCrewRouteRefresh.html',
                        controller: 'CrewRouteRefreshModalCtrl',
                        backdrop: 'static',
                        keyboard: false,
                        size: 'md',
                        resolve: {
                            crewroute: function () { return crewRoute}, 
                            crewRouteDuty: function () { return  crewRouteDuty },
                            dutyNo: function () { return  Number(dutyNo) },
                            dutyDay: function () { return  Number(dutyDay) },
                            forCurrentDay: function() { return scope.flight.FlightDate},
                            }
                        });
                    
                        modalInstance.result.then(function (transferData) {
                            scope.lastSync = new Date().getTime();
                            if(transferData.sync){
                                SyncLogFactory.forceSync();
                                $location.path("/");            //crew route has significantly changed
                            }
                            else if(transferData.refresh){
                                $route.reload();                //crew route was updated
                            }
                        });
                }


                /**
                 * Show Popover that advices User to sync so he can get the latest Pax and Gate Informations
                 * @memberof flightFooter  
                 */
                function showSyncPopover() {
                    var firstSyncWarning = departure - 4500000; //75 mintes before takeoff
                    var secondSyncWarning = departure - 600000; //10 minutes before takeoff
                    var now = new Date().getTime();
                    var lastSync = scope.lastSync;

                    if ((now > firstSyncWarning && now < secondSyncWarning && (!lastSync || lastSync < firstSyncWarning)) || (now > secondSyncWarning && now < departure && (!lastSync || lastSync < secondSyncWarning))) {
                        scope.enableSyncPopover = true;
                    }
                }

                /**
                 * Calculate the time difference of pax info list from now
                 * @memberof flightFooter  
                 */
                function returnTimeDiff() {
                    //time difference in minutes from: now and pax info list date
                    scope.paxTimeDiffInMins = Math.round((new Date().getTime() - new Date(scope.paxInfo.LastRun).getTime()) / 60000);
                }

                var reportsPopoverTemplateUrl = 'views/directives/reportsPopover.tpl.html';


                if (state == 'pax' || state == 'flight' && scope.paxInfo) {
                    var now = new Date().getTime();
                    var departure = new Date(scope.flight.ScheduledDeparture).getTime();

                    if (departure < now) {
                        var openSyncPopover = $interval(showSyncPopover, delay);
                    }
                }

                if (state == 'pax' || state == 'flight') {
                    if (scope.paxInfo && (new Date(scope.flight.ScheduledDeparture).getTime() > new Date().getTime())) {
                        returnTimeDiff();
                        var showTimeDiff = $interval(returnTimeDiff, delay);
                    }
                }

                scope.showAssessment = showAssessment;
                scope.showFlightReport = showFlightReport;
                scope.hasMultipleReports = hasMultipleReports;
                scope.reportsPopoverTemplateUrl = reportsPopoverTemplateUrl;
                scope.gotoFAQs = gotoFAQs;
                scope.gotoRequests = gotoRequests;
                scope.gotoFlight = gotoFlight;
                scope.previousFlight = flights.previousFlight;
                scope.nextFlight = flights.nextFlight;
                scope.gotoBucketCalendar = gotoBucketCalendar;
                scope.gotoCalendar = gotoCalendar;
                scope.gotoFlightInfo = gotoFlightInfo;
                scope.openCabinReport = openCabinReport;
                scope.logout = logout;
                scope.resetDevice = resetDevice;
                scope.deleteAllReports = deleteAllReports;
                scope.gotoMessageLibrary = gotoMessageLibrary;
                scope.gotoPaxInfo = gotoPaxInfo;
                scope.gotoMemosLibrary = gotoMemosLibrary;
                scope.RefreshRoute = RefreshRoute;
                scope.showPopover = false;
                scope.showMobileMenu = false;
                scope.userPosition = user.position;
                scope.openAssessment = openAssessment;
                scope.openSaAssessment = openSaAssessment;
                scope.gotoTicket = gotoTicket;
                scope.goToSafetyReport = goToSafetyReport;
                scope.goToFatigueReport = goToFatigueReport;

                scope.syncWarning = $sce.trustAsHtml('<div class="border-left-orange" style="padding-left: 0.3em"><i class="text-orange fa fa-exclamation-triangle"></i> You are <strong>strongly</strong> advised to sync your device.</div>');
                scope.enableSyncPopover = false;
                scope.lastSync = null;

                element.on('$destroy', function () {
                    $interval.cancel(openSyncPopover);
                    $interval.cancel(showTimeDiff);
                });

            }
        }


        return {
            restrict: 'E',
            terminal: true,
            templateUrl: "views/Flight/footer.tpl.html",
            scope: false,
            link: link
        }

    }

})();